var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.className,attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v(_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }